<template>
  <div v-if="currentItem" class="w-full">
    <h3 class="mb-4 font-semibold text-gray-900">
      {{ currentItem.title }}
    </h3>

    <ul
      class="items-center w-full text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg sm:flex"
    >
      <li
        v-for="(option, index) in currentItem.options"
        :key="index"
        class="w-full border-b border-gray-200 sm:border-b-0 sm:border-r"
      >
        <div class="flex items-center ps-3">
          <input
            type="radio"
            :id="'option-' + index"
            :value="option"
            name="list-radio"
            class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500"
            @change="selectOption(option)"
          />
          <label
            :for="'option-' + index"
            class="w-full py-3 ms-2 text-sm font-medium text-gray-900"
          >
            {{ option }}
          </label>
        </div>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { dataExtinguisher } from "../../../store";

const props = defineProps({
  checklist: Array, // Recebe o array de perguntas e opções
});

const store = dataExtinguisher.state;
const currentIndex = ref(0);

// Obtém o item atual do checklist
const currentItem = computed(() => props.checklist[currentIndex.value]);

const selectOption = (option) => {
  if (!store.maintenanceForm.checklist) {
    store.maintenanceForm.checklist = [];
  }

  // Salva a resposta no store
  store.maintenanceForm.checklist.push({
    question: currentItem.value.title,
    answer: option,
  });

  // Avança para a próxima pergunta, se houver
  if (currentIndex.value < props.checklist.length - 1) {
    currentIndex.value++;
  } else {
    console.log("Checklist concluído!", store.maintenanceForm.checklist);
  }
};
</script>
